<template lang="pug">
extends order-layout-add-cell-base.pug
block content
    .list.inset
        .list-item.pointer(v-for="promotion in promotionList", :key="promotion.id", @click="toggleItem(promotion)")
            .list-body
                p.pull-right
                    i.material-icons.md-24(:class="{ 'item-checked': itemAdded(promotion), 'text-muted': !itemAdded(promotion) }") {{ itemAdded(promotion) ? 'check_box' : 'check_box_outline_blank' }}
                span._400.block {{ promotion.name }}
                span._500.block {{ type(promotion) }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import addCellMixin from './mixins/order-layout-add-cell';
import PromotionTypes from '@js/store/promotion-types';

export default {
    mixins: [addCellMixin],

    computed: {
        ...mapGetters('promotion', ['promotionList', 'totalRecords']),

        options() {
            return this.promotionList;
        },
    },

    created() {
        this.getPromotions();
        this.setItemType('promotion');
    },

    methods: {
        ...mapActions('promotion', ['getPromotionList']),

        getPromotions() {
            let options = {
                query: this.query,
                limit: this.pagination.perPage,
                page: this.pagination.page,
                outlet_id: this.orderLayout.outlet_id,
            };

            this.startLoading('fetch-promotions');
            this.getPromotionList(options).then(res => {
                this.endLoading('fetch-promotions');
            });
        },

        fetchByQuery: _.debounce(function() {
            this.setPage(1);
            this.$refs.pagination.setPage(1);
            this.getProducts();
        }, 500),

        onPaginate(page) {
            this.setPage(page);
            this.getPromotions();
        },

        type(promotion) {
            let type = PromotionTypes.find(t => t.value === promotion.type);
            return type ? type.name : 'Unknown';
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-add-promotion.vue